import React, { useState } from "react";
import { QRCodeCanvas } from "qrcode.react";

const QrCodeGenerator = () => {

    const userId = localStorage.getItem("userId")
  const link = `https://app.qureohealth.com/scan/${userId}`; // your link here

  return (
    <div style={{ textAlign: "center", padding: 20 }}>
      <h3>Scan to Pay</h3>
      <QRCodeCanvas
        value={link}
        size={180}
        bgColor="#ffffff"
        fgColor="#000000"
        level="H"
        includeMargin={true}
      />
      <p style={{ marginTop: 10 }}>{link}</p>
    </div>
  );
};

export default QrCodeGenerator;
